import {Fragment, useState} from 'react';
import {Link} from 'react-router-dom';
import {useForm} from 'react-hook-form';

import Button from 'components/Button';
import TextField from 'components/TextField';
import Logo from 'components/Logo';
import Typography from 'components/Typography';

import {validateEmail} from 'utils/validators';

import styles from './ForgotPassword.module.scss';
import api from 'api';
import {get} from 'lodash';
import toast from 'react-hot-toast';
import Layout from 'components/Layout';

interface FormValue {
  email: string;
}

function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm<FormValue>();

  async function submit(data: FormValue) {
    try {
      setLoading(true);
      await api.post('/users/forgot-password/', data);
      setDone(true);
    } catch (err) {
      let error_message = '';
      const error = get(err, 'response.data', {});
      Object.keys(error).forEach((item: any) => {
        const message = error[item as keyof typeof error];

        error_message = typeof message === 'string' ? message : message[0];
      });
      toast.error(error_message);
    } finally {
      setLoading(false);
    }
  }
  return (
    <Layout>
      <div className={styles.root}>
        <div className={styles.content}>
          <div className={styles.logo}>
            <Logo style={{width: 50, height: 50, filter: 'invert(0)'}} />
          </div>

          {done ? (
            <>
              <Typography variant="h2" textAlign="center">
                Email Sent ✔️
              </Typography>
              <Typography
                className={styles.done}
                variant="h3"
                textAlign="center"
              >
                To reset your password, click on the confirmation link sent to
                the email provided.
              </Typography>
              <Typography style={{textAlign: 'center'}} variant="p">
                Are you remeber your password?{' '}
                <Link className={styles.link} to="/login">
                  Sign in
                </Link>
              </Typography>
            </>
          ) : (
            <Fragment>
              <Typography variant="h2" textAlign="center">
                Forgot Password?
              </Typography>
              <form onSubmit={handleSubmit(submit)}>
                <TextField
                  label="Email address"
                  placeholder="Email"
                  {...register('email', {validate: validateEmail})}
                  error={errors.email?.message}
                />

                <div className={styles.button_container}>
                  <Button
                    type="submit"
                    loading={loading}
                    className={styles.resetPasswordButton}
                  >
                    Reset password
                  </Button>
                </div>
              </form>

              <div className={styles.signup}>
                <Typography variant="p">
                  Already have an account?{' '}
                  <Link className={styles.link} to="/login">
                    Sign in
                  </Link>
                </Typography>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default ForgotPassword;
